import { CATEGORY_CHANCES, CATEGORY_INFOS, CATEGORY_RISKS } from '@/model/post/categories'
import { ACT, PREPARE, WATCH } from '@/model/rating/recommendations'

export default {
    title: {
        [ACT]: 'Section Act',
        [PREPARE]: 'Section Prepare',
        [WATCH]: 'Section Watch'
    },
    tabs: {
        [CATEGORY_INFOS]: {
            title: 'Information'
        },
        [CATEGORY_CHANCES]: {
            title: 'Chances'
        },
        [CATEGORY_RISKS]: {
            title: 'Risks'
        },
        recommendedAction: {
            [ACT]: 'Trends in the section Act: {count}',
            [PREPARE]: 'Trends in the section Prepare: {count}',
            [WATCH]: 'Trends in the section Watch: {count}',
            count: '(0 posts) | (1 post) | ({count} posts)',
            alternative: 'There are no macro-trends in this section'
        }
    }
}
